module.exports = __webpack_public_path__ + "img/location-storage-none.986f8610.svg";